import RecursiveSelector from '@/components/RecursiveSelector';
import VuePhoneNumberInput from 'vue-phone-number-input';
import showAlert from '@waypoint/vue-alert';

import userEscl from '../locales/es-CL/sender.json';
import userEsmx from '../locales/es-MX/sender.json';
import userEsco from '../locales/es-CO/sender.json';
import userEnus from '../locales/en-US/sender.json';

import axios from 'axios';

import Multiselect from 'vue-multiselect';
export default {
  name: 'admin-usuarios',
  components: {
    Multiselect,
    RecursiveSelector,
    VuePhoneNumberInput,
  },
  i18n: {
    messages: {
      'es-CL': {
        sender: userEscl,
      },
      'es-MX': {
        sender: userEsmx,
      },
      'es-CO': {
        sender: userEsco,
      },
      'en-US': {
        sender: userEnus,
      },
    },
  },
  data() {
    return {
      isCrudBusy: false,
      isMainPageBussy: false,
      rowsExcelTranform: [],
      rowsExcel: null,
      fileExcel: null,
      isMassiveActive: false,
      isCreateMode: false,
      dataAccess: null,
      senders: [],
      totalSenders: 0,
      groups: [],
      editMode: false,
      selectedSender: {
        id: null,
        idClient: null,
        name: null,
        legalNumber: null,
        description: null,
      },
      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 15, 20, 50, 100],
      filterKeyword: '',
      defaultCountry: 'CL',
      preferedCountries: ['CL', 'MX', 'US', 'CO'],
      checkedSender: [],
      checkedAllSenders: false,
    };
  },
  created() {
    this.prepareData();
  },
  methods: {
    async prepareData() {
      this.dataAccess = this.$store.getters.dataAccess;
      await this.getSenders();
    },
    async handlePageChange(){
      await this.getSenders();
    },
    async getSenders() {
      this.isMainPageBussy = true;
      try {
        const response = await axios.get(`${this.$store.getters.urlAPI}/sender?pageNum=${this.currentPage}&pageSize=${this.perPage}`, {
          headers: {
            'id-client': this.$store.getters.clientId,
            Authorization: `Bearer ${this.$store.getters.accessToken}`,
          },
        });
        this.senders = response.data.data;
        this.totalSenders = response.data.paginator ? response.data.paginator.totalRows : 0;
        console.log(this.senders);
        this.isMainPageBussy = false;
      } catch (e) {
        console.log(e);
        this.senders = [];
        this.totalSenders = 0;
        this.isMainPageBussy = false;
      }
    },
    openModalCreate() {
      this.isMassiveActive = false;
      this.isCreateMode = true;
      this.selectedSender = {
        id: null,
        idClient: null,
        name: null,
        legalNumber: null,
        description: null,
      };
      this.editMode = false;
      this.showModal('crud-sender');
    },
    openUpdateModal(sender) {
      this.isCreateMode = false;
      this.isMassiveActive = false;
      this.selectedSender.id = sender.id;
      this.selectedSender.idClient = sender.idClient;
      this.selectedSender.name = sender.name;
      this.selectedSender.legalNumber = sender.legalNumber;
      this.selectedSender.description = sender.description;
      this.editMode = true;
      this.showModal('crud-sender');
    },
    openDeleteSender(sender) {
      this.selectedSender = sender;
      this.showModal('confirm-delete');
    },
    async createSender() {
      this.isCrudBusy = true;
      let name = this.checkName();
      let legalNumber = this.checkLegalNumber();
      let isValid = name && legalNumber;
      if (isValid) {
        this.isMainPageBussy = true;
        let body = {
          name: this.selectedSender.name ? this.selectedSender.name : null,
          legalNumber: this.selectedSender.legalNumber ? this.selectedSender.legalNumber : null,
          description: this.selectedSender.description ? this.selectedSender.description : null,
        };
        await this.insertSender(body);
        this.isMainPageBussy = false;
        this.isCrudBusy = false;
      }
    },
    async updateSender() {
      this.isCrudBusy = true;
      let name = this.checkName();
      let legalNumber = this.checkLegalNumber();
      let isValid = name && legalNumber;
      if (isValid) {
        this.isMainPageBussy = true;
        let body = {
          id:  this.selectedSender.id ? this.selectedSender.id : null,
          idClient: this.selectedSender.idClient ? this.selectedSender.idClient : null,
          name: this.selectedSender.name ? this.selectedSender.name : null,
          legalNumber: this.selectedSender.legalNumber ? this.selectedSender.legalNumber : null,
          description: this.selectedSender.description ? this.selectedSender.description : null,
        };
        this.closeModal('crud-sender');
        await this.patchSender(body);
        this.isMainPageBussy = false;
        this.isCrudBusy = false;
      }
    },
    async insertSender(body) {
      try {
        const response = await axios.post(`${this.$store.getters.urlAPI}/sender`, body, {
          headers: {
            'id-client': this.$store.getters.clientId,
            Authorization: `Bearer ${this.$store.getters.accessToken}`,
          },
        });
        if (response.data.status) {
          showAlert(this.$t('common.modals.exitoTitulo'), this.$t('sender.successful.insert'), 'success');
          this.closeModal('crud-sender');
          await this.getSenders();
        }
      } catch (e) {
        this.isMainPageBussy = false;
        console.log(e);
        showAlert(this.$t('common.modals.errorTitulo'), this.$t('sender.error.insert'), 'error');
      }
    },
    async patchSender(body) {
      try {
        const response = await axios.patch(`${this.$store.getters.urlAPI}/sender/${this.selectedSender.id}`, body, {
          headers: {
            'id-client': this.$store.getters.clientId,
            Authorization: `Bearer ${this.$store.getters.accessToken}`,
          },
        });
        if (response.data.status) {
          showAlert(this.$t('common.modals.exitoTitulo'), this.$t('sender.successful.update'), 'success');
          await this.getSenders();
        }
      } catch (e) {
        this.isMainPageBussy = false;
        console.log(e);
        showAlert(this.$t('common.modals.errorTitulo'), this.$t('sender.error.update'), 'error');
      }
    },
    async processDeleteSender(sender) {
      try {
        this.closeModal('confirm-delete');
        this.isMainPageBussy = true;
        const response = await axios.delete(`${this.$store.getters.urlAPI}/sender/${sender.id}`, {
          headers: {
            'id-client': this.$store.getters.clientId,
            Authorization: `Bearer ${this.$store.getters.accessToken}`,
          },
        });
        if (response.data.status) {
          showAlert(
            this.$t('common.modals.exitoTitulo'),
            this.$t('sender.successful.delete', { name: sender.name }),
            'success',
          );
          await this.getSenders();
          this.isMainPageBussy = false;
        }
      } catch (e) {
        this.isMainPageBussy = false;
        console.log(e);
        showAlert(this.$t('common.modals.errorTitulo'), this.$t('sender.error.delete', { name: sender.name }), 'error');
      }
    },
    openMassDeleteModal() {
      this.showModal('confirm-mass-delete');
    },
    async massiveDelete() {
      try {
        this.closeModal('confirm-mass-delete');
        this.isBusy = true;
        const response = await axios.post(`${this.$store.getters.urlAPI}/sender/massDelete`, this.checkedSender, {
          headers: {
            'id-client': this.$store.getters.clientId,
            Authorization: `Bearer ${this.$store.getters.accessToken}`,
          },
        });
        if (response.data.status) {
          showAlert(this.$t('common.modals.exitoTitulo'), this.$t('sender.massModal.successful.massDelete'), 'success');
          await this.getSenders();
          this.isBusy = false;
        }
      } catch (e) {
        this.isBusy = false;
        console.log(e);
        showAlert(this.$t('common.modals.errorTitulo'), this.$t('sender.massModal.error.massDelete'), 'error');
      }
    },
    checkSender: function (e) {
      console.log(e);
      if (this.checkedAllSenders) {
        this.checkAllSender();
      } else {
        this.unCheckAllSender();
      }
    },
    checkAllSender() {
      this.checkedSender = [];
      for (const sender of this.senders) {
        this.checkedSender.push(sender.id);
      }
    },
    unCheckAllSender() {
      this.checkedSender = [];
    },
    closeModal(id) {
      this.$bvModal.hide(id);
    },
    showModal(id) {
      this.$bvModal.show(id);
    },
    checkName() {
      if (this.selectedSender.name) {
        return true;
      }
      this.showPopover('fldName');
      return false;
    },
    checkLegalNumber() {
      if (this.selectedSender.legalNumber) {
        return true;
      }
      this.showPopover('fldLegalNumber');
      return false;
    },
    showPopover(id) {
      const wrongClass = 'form-control-warning';
      const multiselect = document.querySelector(`#${id}`);
      if (multiselect) {
        multiselect.classList.add(wrongClass);
        return;
      }
      if (document.getElementById(id)) {
        document.getElementById(id).classList.add(wrongClass);
      }
    },
    hidePopover(id) {
      const wrongClass = 'form-control-warning';
      const multiselect = document.querySelector(`#${id}`);
      if (multiselect) {
        multiselect.classList.remove(wrongClass);
        return;
      }
    },
  },
  computed: {
    senderField() {
      const common = {
        class: 'text-center',
        tdClass: 'small',
      };
      return [
        {
          key: 'select',
          label: '',
          ...common,
        },
        {
          key: 'name',
          label: this.$t('sender.fields.name'),
          ...common,
        },
        {
          key: 'legalNumber',
          label: this.$t('sender.fields.legalNumber'),
          ...common,
        },
        {
          key: 'description',
          label: this.$t('sender.fields.description'),
          ...common,
        },
        {
          key: 'actions',
          label: this.$t('sender.fields.actions'),
          ...common,
        },
      ];
    },
  },
  watch: {},
};
